export default __webpack_public_path__ + "aa3e11fc98310c26c3830bbde4b582b1.png";